import styled from '@emotion/styled';

const Email = styled('span')(({ theme }) => ({
  margin: '0 1rem 0 0',
  width: '100%',
  ...theme.mixins.ellipsis,
}));

export default Email;
